<div class="relative">
    <p
        class="pointer-events-none absolute -left-1 top-0 z-999 origin-center -translate-y-1/2 scale-75 bg-white px-2 pt-1 text-base"
    >
        <span class="opacity-60">{{ label }}</span>
    </p>

    <div
        class="rounded-md border p-0.5 transition-all focus-within:border-2 focus-within:p-px"
    >
        <!-- main -->
        <div
            class="flex flex-auto overflow-y-auto px-2 pt-0"
            cdkScrollable
        >
            <!-- grid -->
            <au-grid
                [id]="id"
                [columnsConfig]="columnsConfig"
                [gridData]="gridData"
                [gridState]="gridState"
                [originColumnsConfig]="originColumnsConfig"
                [hasSearch]="hasSearch"
                [hasFilterButton]="hasFilterButton"
                [hasPagination]="hasPagination()"
                [pageSizeOptions]="pageSizeOptions()"
                [hasDragAndDrop]="hasDragAndDrop()"
                (action)="action.emit($event)"
                (columnFiltersChange)="columnFiltersChange.emit($event)"
                (columnsConfigChange)="columnsConfigChange.emit($event)"
                (search)="search.emit($event)"
                (stateChange)="stateChange.emit($event)"
                (rowDrop)="rowDrop.emit($event)"
            >
                <ng-template
                    auGridCustomHeaderTemplate
                    position="left"
                >
                    <!-- we can defined buttons from component parent across template directive -->
                    <ng-container *ngIf="gridCustomButtonsHeaderDialogTemplate">
                        <ng-container
                            *ngTemplateOutlet="
                                gridCustomButtonsHeaderDialogTemplate.templateRef;
                                context: {}
                            "
                        ></ng-container>
                    </ng-container>

                    <!-- we can use default button -->
                    <ng-container
                        *ngIf="!gridCustomButtonsHeaderDialogTemplate"
                    >
                        Deprecated default button, implement
                        auGridCustomButtonsHeaderDialogTemplate
                    </ng-container>
                </ng-template>

                <!-- proxy to pass GridElementsManagerCellValueTemplateDirective -->
                <ng-container
                    *ngFor="
                        let gridElementManagerCellValue of gridElementsManagerCellValueTemplate
                    "
                >
                    <ng-template
                        [field]="gridElementManagerCellValue.field"
                        auGridCellValueTemplate
                        let-value
                        let-columnConfig="columnConfig"
                        let-row="row"
                    >
                        <ng-container
                            *ngTemplateOutlet="
                                gridElementManagerCellValue.templateRef;
                                context: { $implicit: value, columnConfig, row }
                            "
                        ></ng-container>
                    </ng-template>
                </ng-container>
            </au-grid>
            <!-- / grid -->
        </div>
        <!-- / main -->
    </div>
</div>
